import * as React from 'react';

import { SlMenuItem } from '@shoelace-style/shoelace/dist/react';

export type TeamSettingMenuItemProps = React.ComponentProps<typeof SlMenuItem>;

export function TeamSettingMenuItem({
  children,
  ...props
}: TeamSettingMenuItemProps) {
  return (
    <SlMenuItem {...props} className="team-settings-menu-item">
      {children}
    </SlMenuItem>
  );
}

TeamSettingMenuItem.Content = function TeamSettingMenuItemContent({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="py-1 px-2 min-w-40 max-w-92 w-fit">
      <div className="font-sans leading-8 text-base font-400 text-blue-900 overflow-ellipsis">
        {children}
      </div>
    </div>
  );
};
